import PropTypes from "prop-types";
import React, { forwardRef, useState } from "react";
import EmailSignup from "./EmailSignup";
import classNames from "classnames";
import { useTrans } from "../../hooks";
import ThirdPartySignup from "./ThirdPartySignup";
import { Button, ButtonVariant, IconNames } from "@wattpad/web-ui-library";

const SignupForm = forwardRef(
  ({ focus = true, formType, nextUrl = "/home", title, toggleForm }, ref) => {
    const { trans } = useTrans();
    const [isEmailFormView, setIsEmailFormView] = useState(false);

    const toggleFormView = () => setIsEmailFormView(!isEmailFormView);

    return (
      //NOTE: This is a temporary div, we can add CSS to signup-form after rollout
      <div className={classNames("auth-form-padding")}>
        <div ref={ref} id="authentication" className="signup-form">
          {!isEmailFormView && (
            <h1
              className="title"
              dangerouslySetInnerHTML={{
                __html: title
                  ? title
                  : trans("Sign up to join the largest storytelling community")
              }}
            />
          )}
          {isEmailFormView && (
            <Button
              className="back-button"
              variant={ButtonVariant.TERTIARY}
              onClick={toggleFormView}
              leadingIcon={IconNames.WpChevronLeft}
              label={trans("Back to all signup options")}
              fullWidth
            />
          )}

          <div className="panel-body">
            {isEmailFormView ? (
              <EmailSignup
                formType={formType}
                nextUrl={nextUrl}
                toggleFormView={toggleFormView}
              />
            ) : (
              <ThirdPartySignup
                focus={focus}
                nextUrl={nextUrl}
                toggleForm={toggleForm}
                toggleFormView={toggleFormView}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
);

SignupForm.displayName = "SignupForm";

SignupForm.propTypes = {
  focus: PropTypes.bool,
  formType: PropTypes.string,
  nextUrl: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  toggleForm: PropTypes.func.isRequired
};

export default SignupForm;
